module.exports = require("@swa-ui/core/src/CloseButton/CloseButton.module.scss");